/*
  Add Custom JS to be layered on top of ciritical theme js
  Events
  
  product:init
  product:variantSelected

  cart:itemAdding
  cart:itemAdded
  cart:updated
  cart:error

  cart:cartOfferComplete

  modal:show
  modal:hide

*/


document.addEventListener("product:init", () => {
  setTimeout(() => {
    window.dispatchEvent(Extend.CustomEvent("variantExtendLoaded", { detail: { variant: Neptune.products[0].variant.id } }));
  }, 50);
});


document.addEventListener("product:variantSelected", () => {
  window.dispatchEvent(Extend.CustomEvent("variantExtendChange", { detail: { variant:_n.qs("[neptune-product]").variant } }))
})


document.addEventListener("cart:updated", function (event) {
  window.dispatchEvent(Extend.CustomEvent('initCart'))
})

document.addEventListener("cart:cartOfferComplete", function (event) {
  window.dispatchEvent(Extend.CustomEvent('initCart'))
})

document.addEventListener("modal:show", function (event) {
  if(event.detail.info=='cart'){
    window.dispatchEvent(Extend.CustomEvent('sideCartOpen'))
  }
})